<template>
    <div class="bg-swiper">
        <swiper :options="swiperOption" ref="bg-swiper">
            <swiper-slide>
                <div class="bg-swiper__slide re"></div>
            </swiper-slide>

            <swiper-slide>
                <div class="bg-swiper__slide it"></div>
            </swiper-slide>

            <swiper-slide>
                <div class="bg-swiper__slide ls"></div>
            </swiper-slide>
        </swiper>
    </div>
</template>


<script>
    export default {
        data () {
            return {
                swiperOption: {
                    loop: true,
                    speed: 800,
                    slidesPerView: 1,
                    autoplay: {
                        delay: 8000
                    },
                    effect: 'fade',
                    lazy: {
                        loadPrevNext: true,
                    }
                }
            }
        }
    }
</script>


<style lang="scss" scoped>
    .bg-swiper {
        width: 100%;
        height: 100%;

        background-color: white;
    }

    .bg-swiper__slide {
        background-position: center;
        background-repeat: no-repeat;
        -webkit-background-size: cover;
        background-size: cover;

        width: 100%;
        height: 100%;

        background-color: white;

        position: absolute;
        top: 0;
        left: 0;
        z-index: 1;
    }

    .re {
        background-image: url("../assets/re.jpg");
    }

    .ls {
        background-image: url("../assets/ls.jpg");
    }

    .it {
        background-image: url("../assets/it.jpg");
    }

    .it2 {
        background-image: url("../assets/it-2.jpg");
    }

    .swiper-container {
        height: 100%;
    }
</style>



// WEBPACK FOOTER //
// src/components/Swiper.vue